import { render, staticRenderFns } from "./AppInputPhoneNumber.vue?vue&type=template&id=5b5d68a8&scoped=true"
import script from "./AppInputPhoneNumber.vue?vue&type=script&lang=js"
export * from "./AppInputPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./AppInputPhoneNumber.vue?vue&type=style&index=0&id=5b5d68a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d68a8",
  null
  
)

export default component.exports